// /* eslint-env browser */
// (function() {
// 	'use strict';

// 	// Check to make sure service workers are supported in the current browser,
// 	// and that the current page is accessed from a secure origin. Using a
// 	// service worker from an insecure origin will trigger JS console errors. See
// 	// http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
// 	var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// 			// [::1] is the IPv6 localhost address.
// 			window.location.hostname === '[::1]' ||
// 			// 127.0.0.1/8 is considered localhost for IPv4.
// 			window.location.hostname.match(
// 				/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
// 			)
// 		);

// 	if ('serviceWorker' in navigator &&
// 			(window.location.protocol === 'https:' || isLocalhost)) {
// 		navigator.serviceWorker.register('service-worker.js')
// 		.then(function(registration) {
// 			// updatefound is fired if service-worker.js changes.
// 			registration.onupdatefound = function() {
// 				// updatefound is also fired the very first time the SW is installed,
// 				// and there's no need to prompt for a reload at that point.
// 				// So check here to see if the page is already controlled,
// 				// i.e. whether there's an existing service worker.
// 				if (navigator.serviceWorker.controller) {
// 					// The updatefound event implies that registration.installing is set:
// 					// https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
// 					var installingWorker = registration.installing;

// 					installingWorker.onstatechange = function() {
// 						switch (installingWorker.state) {
// 							case 'installed':
// 								// At this point, the old content will have been purged and the
// 								// fresh content will have been added to the cache.
// 								// It's the perfect time to display a "New content is
// 								// available; please refresh." message in the page's interface.
// 								break;

// 							case 'redundant':
// 								throw new Error('The installing ' +
// 																'service worker became redundant.');

// 							default:
// 								// Ignore
// 						}
// 					};
// 				}
// 			};
// 		}).catch(function(e) {
// 			console.error('Error during service worker registration:', e);
// 		});
// 	};

	// Your custom JavaScript goes here
	$(document).ready(function () {
		$(".button-collapse").sideNav();
		$('select').material_select();

		// I'm not used to jQuery so I'll just use vanilla JS, I can change it to jQuery if you guys have any doubts!
		//Index client logos box
		const logos = ['images/1.png', 'images/2.png', 'images/3.png', 'images/4.png', 'images/5.png'];
		var actualPicture = 0;

		setTimeout(moveRight, 1000);

		function moveRight(){
			try{
				document.getElementById('clientsLogo').classList.toggle('moveRightAnimation');
				actualPicture++
				if(actualPicture >= logos.length)
					actualPicture = 0;
				setTimeout(changePicture, 500);
			}catch(e){}
		}
		function changePicture(){
			document.getElementById('clientsLogo').setAttribute('src', logos[actualPicture]);
			setTimeout(reset, 800);
		}
		function reset(){
			document.getElementById('clientsLogo').classList.toggle('moveRightAnimation');
			setTimeout(moveRight, 800);
		}
		
		// CONTACT FORM JAVASCRIPT
		const contactButton = document.querySelector('.buttonContact');
		const closeButton = document.querySelector('#formBackground form i')
		const form = document.querySelector('#formBackground');
		const formContent = document.querySelector('#formBackground form');

		contactButton.addEventListener('click', function(e){
			e.preventDefault();
			contactButton.classList.toggle('bigger');
			setTimeout(turnBackground, 350);
		});
		closeButton.addEventListener('click', function(e){
			e.preventDefault();
			formContent.classList.toggle('active');
			setTimeout(turnOffForm, 250);			
		});

		function turnOffForm(){
			form.classList.toggle('active');
			setTimeout(turnOffBigger, 100);
		}
		function turnOffBigger(){
			contactButton.classList.toggle('bigger');
			document.querySelector('.buttonContact .large').style.color = "#2196F3";
			setTimeout(whiteButton, 700);
		}
		function whiteButton(){
			document.querySelector('.buttonContact .large').style.color = "white";
		}
		function turnBackground(){
			form.classList.toggle('active');
			setTimeout(turnForm, 100);
		}
		function turnForm(){
			formContent.classList.toggle('active');
		}
	});

// })();